const CACHE_NAME=process.env.NEXT_PUBLIC_CACHE_NAME || "local"

export const registerServiceWorker = () => {
    if (typeof window === 'undefined') return; // SSR guard

    if ('serviceWorker' in navigator) {
        const registerSW = () => {
            navigator.serviceWorker
                .register(`/clear_sw.js?cacheName=${CACHE_NAME}`)
                .then((registration) => {

                    navigator.serviceWorker.addEventListener('message', (event) => {
                        if (event.data?.type === 'NEW_VERSION_AVAILABLE') {
                            clearSiteData(); // clear site data when a new version is available
                            window.location.reload(); // force reload after clearing data
                        }
                    });
                })
                .catch((error) => {
                    console.log('[SW] Registration failed:', error);
                });
        };

        // If the page is already loaded, register immediately
        if (document.readyState === 'complete') {
            registerSW();
        } else {
            window.addEventListener('load', registerSW);
        }
    }
};

const clearSiteData = () => {
    if (typeof window !== 'undefined') {

        // Clear IndexedDB
        if (indexedDB?.databases) {
            indexedDB.databases().then((dbs) => {
                dbs.forEach((db) => indexedDB.deleteDatabase(db.name));
            });
        }

        // Unregister service workers
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then((regs) => {
                regs.forEach((reg) => reg.unregister());
            });
        }

        // Clear cache storage (used by service workers or fetch)
        if ('caches' in window) {
            caches.keys().then((names) => {
                names.forEach((name) => caches.delete(name));
            });
        }
    }
};
